export function converterParaIso(data: string): string {
  const [dia, mes, ano] = data.split("/");
  if (!dia || !mes || !ano) return "";
  return `${ano}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
}
